var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-one",style:({ backgroundImage: `url(${_vm.backgroundUrl})` })},[_c('div',{staticClass:"content"},[_c('h5',[_vm._v(_vm._s(_vm.companyName))]),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h6',[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }